import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import { formatViews } from "@/lib/movies";

interface MovieCardProps {
  movie: Movie;
  isFavorite?: boolean;
  onToggleFavorite?: (id: string) => void;
  showFavorite?: boolean;
}

export default function MovieCard({
  movie,
  isFavorite = false,
  onToggleFavorite,
  showFavorite = true,
}: MovieCardProps) {
  return (
    <div className="group relative">
      <Link
        to={`/detail/${movie.id}`}
        className="block overflow-hidden rounded-lg bg-background-100"
      >
        <div className="relative w-full aspect-[2/3] overflow-hidden">
          <img
            src={movie.poster}
            alt={`${movie.title} 海报`}
            title={`${movie.title} 91免费看片`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" />
          <span className="absolute left-2 top-2 rounded-md bg-accent-500 px-1.5 py-0.5 text-[11px] font-semibold text-background-50">
            {movie.type}
          </span>
          <span className="absolute right-2 top-2 rounded-md bg-black/55 px-1.5 py-0.5 text-[11px] font-semibold text-accent-300">
            {movie.rating.toFixed(1)}
          </span>
          <div className="absolute inset-x-0 bottom-0 p-2.5">
            <p className="truncate text-sm font-semibold text-white">
              {movie.title}
            </p>
            <p className="mt-0.5 truncate text-[11px] text-white/75">
              {movie.year} · {movie.region} · {movie.genres.slice(0, 2).join(" ")}
            </p>
          </div>
          <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500/90 text-background-50">
              <i className="ri-play-fill text-xl" />
            </span>
          </div>
        </div>
      </Link>

      {showFavorite && onToggleFavorite && (
        <button
          type="button"
          aria-label={isFavorite ? "取消收藏" : "收藏"}
          onClick={(e) => {
            e.preventDefault();
            onToggleFavorite(movie.id);
          }}
          className={`absolute right-2 top-9 flex h-7 w-7 cursor-pointer items-center justify-center rounded-full backdrop-blur transition-colors ${
            isFavorite
              ? "bg-accent-500 text-background-50"
              : "bg-black/45 text-white hover:bg-black/65"
          }`}
        >
          <i
            className={`text-sm ${
              isFavorite ? "ri-heart-fill" : "ri-heart-line"
            }`}
          />
        </button>
      )}

      <div className="mt-2 flex items-center gap-1 text-[11px] text-foreground-500">
        <i className="ri-fire-line text-accent-500" />
        <span>{formatViews(movie.views)}次播放</span>
      </div>
    </div>
  );
}